import templates from "../templates";

import jQuery from "jquery";
import { MOBILE_BREAKPOINT } from "../data/constants";
import DATA from "../data/data";
import itinaryService from "../services/itinary";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import { DistanceProvider } from "../stores-js/location/distanceprovider";
import DetailView from "./detailView";
import DirectionsView from "./directionsView";
import ResultsView from "./resultsView";
import SearchOnRouteView from "./searchOnRouteView";
import SearchView from "./searchView";

const $ = jQuery;

export default class SidePanel {
    constructor(
        mapView,
        language,
        storeId,
        mobileDetailMapDisplay,
        autocompleteByName,
        business,
        location,
        searchQuery,
    ) {
        this.selector = "#storemap-sidebar-container";
        this.mainElement = document.querySelector(this.selector);
        this.mainElement.innerHTML = templates.desktop.sidePanel.render(total.maps.L10n.ui);

        this.VIEWS = {
            searchView: "searchView",
            searchResultView: "searchResultView",
            detailsView: "detailsView",
            destinationView: "destinationView",
        };

        this.directionPreviousView = null;

        this.currentView = null;

        this.mapView = mapView;

        this.selectedStore = null;
        this.location = null;

        this.searchView = new SearchView(this, autocompleteByName, business);
        this.resultsView = new ResultsView(this);
        this.detailView = new DetailView(this, language);
        this.directionsView = new DirectionsView(this);
        this.searchOnRouteView = new SearchOnRouteView(this);
        this.storeSelectedFromMap = false;
        this.detailFromItinerary = false;

        this.showDetailView = () => {
            this.currentView = this.VIEWS.detailsView;
            if (!SETTINGS.isSearchAlongTheRouteActive) {
                this.searchView.show();
                this.searchOnRouteView.hide();
            }
            this.resultsView.hide();
            this.detailView.show();
            this.directionsView.hide();
        };

        this.showSearchResultView = () => {
            // this.searchView.show();
            this.detailView.hide();
            this.directionsView.hide();

            if (SERVICE_REGISTRY.locationService.isUserCurrentLocation()) {
                this.currentView = this.VIEWS.searchResultView;
                this.resultsView.show();
                this.resultsView.scrollToSelectedStore();

                if (this.selectedStore && !this.resultsView.isStoreInList(this.selectedStore.properties.store_id)) {
                    SERVICE_REGISTRY.storeService.resetSelectedStore();
                }
            } else {
                this.currentView = this.VIEWS.searchView;
                this.resultsView.hide();
                SERVICE_REGISTRY.storeService.resetSelectedStore();
                SERVICE_REGISTRY.storeService.resetStores();
            }
        };

        this.showDirectionView = () => {
            this.directionPreviousView = this.currentView;
            this.currentView = this.VIEWS.destinationView;
            this.searchView.hide();
            this.resultsView.hide();
            this.detailView.hide();
            this.directionsView.show();
            this.searchOnRouteView.hide();
        };

        this.closeDirectionView = () => {
            if (this.directionPreviousView === this.VIEWS.detailsView) {
                this.detailView.showDetails(SERVICE_REGISTRY.storeService.getSelectedStore());
                this.showDetailView();
            } else if (this.directionPreviousView === this.VIEWS.searchResultView) {
                this.showSearchResultView();
            } else {
                this.showSearchResultView();
                this.set("stores", []);
            }
            this.detailFromItinerary = false;
        };
        this.resumeDirectionView = () => {
            this.currentView = this.VIEWS.destinationView;
            const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
            // Restore directions panel layout
            if (!isMobile) {
                this._setDirectionsModeLayout(true);
            }
            this.searchView.hide();
            this.resultsView.hide();
            this.detailView.hide();
            SERVICE_REGISTRY.storeService.resetSelectedStore(); // deselects POI marker & highlight
            this.directionsView.mainElement.show();
            this.searchOnRouteView.hide();
            this.detailFromItinerary = false;
        };

        this.swapItineraryDestination = () => {
            // Commit the browsed station as the new destination while keeping
            // the existing origin (preserved inside directionsView.userLocation).
            // Must run BEFORE resumeDirectionView(): onSelectedStoreChange reads
            // selectedStore via setStore(), and resumeDirectionView resets it.
            this.directionsView.onSelectedStoreChange();
            this.resumeDirectionView();
        };

        this.resetView = () => {
            this.searchView.show();
            this.resultsView.hide();
            this.detailView.hide();
            this.directionsView.hide();
            this.searchOnRouteView.hide();
            this.searchOnRouteView.onResetSearchOnRouteView();
            this.detailFromItinerary = false;
        };

        // prepate detail map view
        this.displayDetailMap = () => {
            this.mainElement.hide();
            document.querySelector("#storemap-map-directionbutton").style.display = "";
            // force direction view on side panel
            this.showDirectionView();
            document.querySelector(
                "#storemap-directionsearchbar-container .storemap-directionsearchbar-close-button",
            ).style.visibility = "hidden";
        };

        // prepate detail map view
        this.displayMobileDetailMap = () => {
            this.mainElement.hide();
        };

        // Distance

        this.woosmapDistanceProvider = new DistanceProvider();
        // FIXME: this descision does not belong to the side panel.
        // If store_id present in url, only show this store on the map
        if (storeId) {
            DATA.getStoreById(storeId, (data) => {
                const store = data.features[0];

                if (store) {
                    SERVICE_REGISTRY.storeService.setSelectedStore(store);
                    /* FIXME: HACKERMAN was here, this should be redone with a search result layer based on woosmap.map.Data.
          mapView.tiledView.set('stores', [store]);
          setTimeout(() => {
            mapView.tiledView._map.setZoom(15);
          }, 500);
          mapView.tiledView._map.setCenter({
            lat: store.geometry.coordinates[1],
            lng: store.geometry.coordinates[0],
          });
           */
                    if (mobileDetailMapDisplay) {
                        this.displayMobileDetailMap();
                    } else {
                        this.displayDetailMap();
                    }
                } else {
                    console.warn(`The store ${storeId} does not exist`);
                }
            });
        } else {
            this.showSearchResultView();
        }

        const sideBarContainer = document.querySelector("#storemap-sidebar-container");
        const mapCanvas = document.querySelector("#map-canvas");

        if (location && searchQuery) this.searchView.setLocation(location, searchQuery);

        window.addEventListener("resize", () => {
            // Fix side panel height
            // Bug IE 9-11 qui ne prend pas en compte la fonction CSS calc dans le cas où le HTML est généré dynamiquement
            const height = mapCanvas.getBoundingClientRect().height;

            // if (this.currentView === this.VIEWS.detailsView || this.currentView === this.VIEWS.searchResultView) {
            //     sideBarContainer.style.height = `${height - 80}px`;
            //     sideBarContainer.style.borderBottomWidth = 0;
            // } else {
            //     sideBarContainer.style.maxHeight = `${height - 80}px`;
            // }
            // sideBarContainer.style.height = 100 + "vh";
        });
    }

    onCenterChange() {
        if (this.currentView === this.VIEWS.searchResultView) {
            this.resultsView.onCenterChange();
        }
    }

    onRefreshList(center) {
        this.searchView.onRefreshList(center);
    }

    onSelectedStoreChange(selectedStore) {
        if (selectedStore === null) return;

        //dismiss the stale predictions overlay on any store selection so it doesn't stack over the detail view.
        this.searchView.dismissPredictions();

        this.selectedStore = selectedStore;

        if (this.currentView === this.VIEWS.searchView) {
            this.detailView.showDetails(selectedStore);
            this.showDetailView();
        } else if (this.currentView === this.VIEWS.searchResultView) {
            if (this.resultsView.isStoreInList()) {
                SERVICE_REGISTRY.storeService.setSelectedStoreForDetail(selectedStore);
                // TO DO - REVISIT THIS FUNCTIONALITY
                this.resultsView.showSingleModeCard(this.selectedStore.properties.store_id);
            } else {
                this.detailView.showDetails(SERVICE_REGISTRY.storeService.getSelectedStore());
                this.showDetailView();
            }
        } else if (this.currentView === this.VIEWS.detailsView) {
            this.detailView.showDetails(selectedStore);
        } else if (this.currentView === this.VIEWS.destinationView) {
            if (this.storeSelectedFromMap) {
                this.detailFromItinerary = true;
            }
            this.detailView.showDetails(selectedStore);
            if (this.storeSelectedFromMap) {
                const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
                if (isMobile) {
                    // Mobile: keep directions panel, show minified card alongside
                    this.currentView = this.VIEWS.detailsView;
                    this.detailView.show();
                } else {
                    // Desktop: hide directions panel, show detail view
                    // Switch layout mode so content area becomes visible
                    this._setDirectionsModeLayout(false);
                    this.showDetailView();
                }
            } else {
                this.directionsView.onSelectedStoreChange();
            }
        }
    }

    onStoreForDetailChange(store) {
        if (store && !$.isEmptyObject(store)) {
            this.showDetailView();
            this.detailView.showDetails(store);
        }
    }

    updateStoreDistance(stores, callback) {
        if (SERVICE_REGISTRY.locationService.isUserCurrentLocation()) {
            this.woosmapDistanceProvider.location = SERVICE_REGISTRY.locationService.getLocation();
            // this.woosmapDistanceProvider.updateStoresDistanceWithGoogle(stores, callback);
            DATA.updateStoresWithWoosmapDistanceApi(stores, callback);
        } else {
            callback(stores);
        }
    }

    onNearbyStoresChange(nearbyStores) {
        if (SERVICE_REGISTRY.locationService.isUserCurrentLocation()) {
            if (
                this.currentView === this.VIEWS.searchView ||
                this.currentView === this.VIEWS.searchResultView ||
                this.currentView === this.VIEWS.detailsView
            ) {
                if (nearbyStores !== null && nearbyStores.length !== 0) {
                    this.showSearchResultView();
                    this.updateStoreDistance(nearbyStores, (updatedStores) => {
                        this.resultsView.setStores(updatedStores);
                        this.mapView.onNearbyStoresChange(updatedStores);
                    });
                } else {
                    this.resultsView.setStores([]);
                }
            }
        }
    }

    onItinaryStoresChange(itinaryStores) {
        if (this.currentView === this.VIEWS.searchView || this.currentView === this.VIEWS.searchResultView) {
            if (itinaryStores !== null && itinaryStores.length !== 0) {
                this.showSearchResultView();
                this.resultsView.setStores(itinaryStores);
            } else {
                this.resultsView.setStores([]);
            }
        }
    }

    onUniqueStoreChange(store) {
        this.detailView.showDetails(store);
        this.showDetailView();
    }

    onQueryFilterChange() {
        // only if user add a location to search nearby stores
        if (SERVICE_REGISTRY.locationService.isUserCurrentLocation()) {
            SERVICE_REGISTRY.storeService.updateNearbyStores();
        }
    }

    getSearchViewHeight() {
        const searchMainElement = this.searchView.mainElement;
        let searchViewHeight = searchMainElement.height();
        searchViewHeight +=
            Number.parseInt(searchMainElement.css("padding-top"), 10) +
            Number.parseInt(searchMainElement.css("padding-bottom"), 10);

        return searchViewHeight;
    }

    onLocationReset() {
        this.resultsView.removeResultList();
        this.showSearchResultView();
    }

    onStoresReset() {
        this.currentView = this.VIEWS.searchView;
        SERVICE_REGISTRY.storeService.resetSelectedStore();
        this.resultsView.setStores([]);
        this.resultsView.hide();
        this.detailView.hide();
    }

    toggleDirectionView() {
        this.mainElement.toggle();
        this.directionsView.clearOriginInput();
    }
    setStoreSelectedFromMap = (state) => {
        this.storeSelectedFromMap = state;
    };
    getStoreSelectedFromMap = () => {
        return this.storeSelectedFromMap;
    };
    onResetHighlightedStoreOnRoute = () => {
        this.mapView.onResetHighlightedStoreOnRoute();
    };
    isDetailFromItinerary = () => {
        return this.detailFromItinerary;
    };
    _setDirectionsModeLayout = (enabled) => {
        const panel = document.querySelector(".wm-panel");
        const locator = document.querySelector(".storemap-store-locator");
        if (panel && locator) {
            if (enabled) {
                panel.classList.add("wm-directions-mode");
                panel.classList.remove("wm-poi-list-mode");
                locator.classList.add("wm-directions-mode");
                locator.classList.remove("wm-poi-list-mode");
            } else {
                panel.classList.remove("wm-directions-mode");
                panel.classList.add("wm-poi-list-mode");
                locator.classList.remove("wm-directions-mode");
                locator.classList.add("wm-poi-list-mode");
            }
        }
    };
}
